import { render, staticRenderFns } from "./GoodsSkus.vue?vue&type=template&id=3a18ebb9&scoped=true&lang=pug&"
import script from "./GoodsSkus.vue?vue&type=script&lang=ts&"
export * from "./GoodsSkus.vue?vue&type=script&lang=ts&"
import style0 from "./GoodsSkus.vue?vue&type=style&index=0&id=3a18ebb9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a18ebb9",
  null
  
)

export default component.exports